import React, { Component } from 'react'
import {
  withStyles,
  Typography,
  Divider,
  CircularProgress,
  Paper,
  Link,
  Fade,
} from '@material-ui/core'
import Cookies from 'js-cookie'
import LostOpp from '../lostOpp/LostOpp'
import { BiDirections } from 'react-icons/bi'
import PageHeader from '../PageHeader'

const base_url = "https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/"

const styles = theme => ({
  pageTitle: {
		fontFamily: 'Roboto, sans-serif',
    fontSize: '17px',
    fontWeight: 'light',
    color: 'rgba(115, 115, 115, 0.9)'
	},
	pageTitleDark: {
		fontFamily: 'Roboto, sans-serif',
    fontSize: '17px',
    fontWeight: 'light',
    color: 'rgba(255, 255, 255, 0.9)'
	},
	pageIcon: {
		fontSize: '15px',
		marginTop: '21px',
		marginRight: '2px',
	},
	pageIconDark: {
		fontSize: '15px',
		color: 'rgba(255, 255, 255, 0.9)',		
		marginRight: '2px',
	},
  lostOppLink: {
    color: '#25aae1',
    '&:hover': {
      cursor: 'pointer',
      color: '#25aae1'
    }
  },
})

class BoomLostOpp extends Component {
  _isMounted = false

  constructor() {
    super()
    this.state = {
      isLoading: true,
      lostOppData: [],
      darkMode: JSON.parse(localStorage.getItem("darkMode")) !== null ? JSON.parse(localStorage.getItem("darkMode")) : true
    }
  }

  componentDidMount = () => {
    this._isMounted = true

    fetch(`${base_url}/boomLostOpp`, {
			headers: {
				token: Cookies.get('token')
			}
		})
		.then(response => response.json())
		.then(data => {
			// console.log(data)
			if(this._isMounted && data) {
				this.setState({
					isLoading: false,
					lostOppData: data
				})
			} else {
				this.setState({
					isLoading: false,
					lostOppData: []
				})
			}
		})
		.catch(error => {
			console.log(error)
		})
  }

  render() {
    const { classes } = this.props
    return(
      <div className="lost-opps">
        {this.state.isLoading ? <CircularProgress /> :
          <div>
            <div>
              <PageHeader details={{icon: <BiDirections />, title: "BOOMERANG LOST OPPORTUNITY"}}/>            
              <Typography variant="caption" style={{fontSize: '12px', marginTop: '10px', width: 100, color: `${this.state.darkMode ? "#fff" : "#6e6e6e"}`}}>
                VIEW BOOMERANG ROI <Link className={classes.lostOppLink} href={'/boomerang/lost-opportunity'}>HERE</Link>
              </Typography>
            </div>
            <br/>
            <LostOpp lostOppData={this.state.lostOppData}/>
          </div>
        }
      </div>
    )
  }
}

export default withStyles(styles)(BoomLostOpp)
